<template>
    <h3 class="font-weight-bold text-uppercase text-center py-12">
        {{ title }}
    </h3>
</template>

<script>
    export default {
        name: 'HomeTitle',
        props: {
            title: {
                required: true,
                type: String,
            }
        }
    }
</script>

<style scoped>

</style>
